import styled from 'styled-components'

export const BlogNavigation = styled.div`
  background: #fff5f6;
  padding: 28px 0;
  width: 100%;

  @media (max-width: 1150px) {
    height: 50px;
    padding: 0;
  }
`

export const BlogLogo = styled.img`
  margin-right: 100px;
  margin-bottom: -4px;
  cursor: pointer;

  @media (max-width: 1150px) {
    height: 22px;
    margin-right: 10px;
    margin-left: 16px;
  }
`

export const BlogNavigationInnerContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  margin: auto;

  & h1 {
    display: none;
  }

  @media (max-width: 1150px) {
    height: 50px;
    margin: 0;
    width: auto;
    align-items: center;
  }
`

export const Tabs = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  max-width: 1150px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1150px) {
    overflow: auto;
    box-sizing: border-box;
    margin-bottom: 18px;
    padding-left: 15px;
    margin-top: 10px;
  }

  @media (max-width: 1150px) {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;
    align-self: flex-end;
  }
`

export const Tab = styled.a`
  border: none;
  background: transparent;
  font-weight: ${props => (props.active ? '700' : '500')};
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.01em;
  border-bottom: 3px solid ${props => (props.active ? 'black' : 'transparent')};
  padding: 0 5px 10px;
  color: ${props => (props.active ? 'black' : '#333333')};
  cursor: pointer;
  white-space: nowrap;

  @media (max-width: 1150px) {
    margin: 0 9px;
  }

  @media (max-width: 1150px) {
    font-size: 13px;
    line-height: 22px;
    border-width: 2px;
    margin-left: 0;
    margin-right: 15px;
  }

  &:hover {
    border-bottom: 3px solid black;
    color: black;
  }
`
